<template>
  <div class="page-container">
    <UiModal
      title="Eroare disponibilitate"
      subtitle="Ședinte acum"

      @settings="blockingModalSettings"
      @close="blockingModalClose"

      :buttons="[
        {
          event: 'settings',
          style: 'gradient',
          text: 'Setări disponibilitate'
        },
        {
          event: 'close',
          text: 'Închide'
        }
      ]"

      v-if="user && !(user.overtime)"
    >
      <template slot="body">
        <h3 class="anytime-meetings__warning">
          Pagină indisponibilă
        </h3>
        <h4 class="anytime-meetings__warning">
          Vă rugăm să revizuiți setările pentru disponibilitate.
        </h4>
      </template>
    </UiModal>

    <template v-else>
      <div class="page-container__header">
        <h1 class="header-1 page-container__title">
          Ședințe acum
        </h1>
      </div>
      <div class="page-container__body" :class="{ 'show-chat': showChat }" v-if="this.user">
        <div class="am__card">
          <h3 class="am__header">
            Listă de așteptare
          </h3>

          <div class="am__padding">
            <h2 style="margin-bottom: 20px;">
              Utilizatori în așteptare ({{ queue.length }})
            </h2>

            <div class="am__table">
              <div class="am__table-head">
                <h4>Poziție</h4>
                <h4>Nume client</h4>
                <h4>Timp de așteptare</h4>
              </div>

              <div class="am__client" v-for="(client, index) in queue" :key="client.id">
                <h4>
                  <span>{{ index + 1 }}</span>
                </h4>

                <h4>
                  {{ client.client_name }}
                </h4>

                <h4>
                  {{ clientWaitingTime(client.joined_at) }}
                </h4>
              </div>
            </div>

            <h2 class="am__time-to-wait">
              Preț (/min):
              <span>
                {{ this.user.minute_price }}
                <img src="@/assets/images/icons/coins.svg" style="color: black;" alt=""> 
              </span>
            </h2>
            <h2 style="margin-bottom: 20px;">
              Acțiuni
            </h2>

            <div class="am__actions">
              <UiButton
                @click="inviteNextClient"
                :icon="remainingTime === null ? null : 'fas fa-user-clock'"
                :name="remainingTime === null ? 'Invită următorul client' : `00:${
                  remainingTime < 10 ? `0${remainingTime}` : remainingTime
                }`"
                :disabled="remainingTime !== null || this.queue.length == 0 || (anytimeWidget && anytimeWidget.meeting)"
              />
              <UiButton
                @click="showChat = true"
                name="Vezi anunțurile"
              />
              <UiButton
                @click="unavailable"
                :disabled="remainingTime !== null"
                name="Indisponibil"
              />
            </div>
          </div>
        </div>
        <div class="am__card am__card--chat">
          <h3 class="am__header" style="justify-content: flex-start;">
            <span @click="showChat = false">
              <i class="fas fa-chevron-left" />
              Înapoi
            </span>
            <h3 class="am__header" style="background: transparent; width: calc(100% - 160px);">
              Anunțuri
            </h3>
          </h3>
          <div class="chat__container" ref="chat">
            <div class="chat__message" v-for="message in chat" :key="message.id">
              <div class="message__meta">
                <h4 class="message__name">
                  {{ user.full_name }}
                </h4>
                <h4 class="message__datetime">
                  {{ message.created_at | moment('from') }}
                </h4>
              </div>
              <p class="message__text header-5">
                {{ message.text }}
              </p>
            </div>
          </div>
          <div class="chat__input">
            <input
              placeholder="Scrie un anunț"
              v-model="message"
              @keyup.enter="sendMessage"
            />
            <i
              class="fas fa-paper-plane"
              @click="sendMessage"
            />
          </div>
        </div>
      </div>
      <div class="page-container__body" v-else>
        <div style="text-align:center;">
          Se încarcă..
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import UiButton from '@/components/ui/Button.vue'
  import UiModal from '@/components/ui/Modal.vue'
  import { mapGetters } from 'vuex'
  import { mapActions } from 'vuex'

  import * as moment from 'moment';

  export default {
    components: { UiButton, UiModal },
    data() {
      return {
        // Current announcement v-model input
        message: '',
        // Remaining seconds for user to accept the invite
        remainingTime: null,
        // Show chat and hide queue
        showChat: false,
        chat: [],
        price: 5,
        queueChannel: null,
        queue: [],
        /**
         * Paul (friendly reminder): nu uita că s-ar putea să apară un bug legat de reactivitate când se computează joined_at cu moment.js.
         * Rares: M-am gandit la asta. Momentan am pus un setInterval care forteaza re-randarea userilor in queue din minut in minut.
         * Nu cred ca avem nevoie de precizie mai mare.
         * Paul: Perfect
         */
      };
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            anytimeWidget: 'layout/anytimeWidget'
        })
    },
    methods: {
      ...mapActions({
			  refreshUser: 'user/user',
        updateTimetable: 'settings/updateTimetable'
		  }),
      blockingModalSettings() {
        this.$router.push({ path: '/specialist/settings', hash: 'disponibilitate' });
      },
      blockingModalClose() {
        this.$router.push({ path: '/specialist/stats' });
      },
      clientWaitingTime(joinedAt){
        return moment().diff(moment(joinedAt), 'minutes') + ' minute';
      },
      inviteNextClient() {
        if (this.remainingTime !== null) {
          return;
        }

        //I.Send invite
        let eventData = {
          event: 'invite',
          queue_channel: this.queueChannel,
          specialist_id: this.user.id,
        }
        this.$socket.emit('anytime_specialist', eventData);

        //II.Start cooldown timer
        this.remainingTime = 35;
        const interval = setInterval(() => {
          this.remainingTime--;

          if (this.remainingTime === 0) {
            clearInterval(interval);
            this.remainingTime = null;
          }
        }, 1000);
      },
      unavailable() { 
        //TODO: I.Set specialist unavailable from API @andreipredafl
        //II.Emit unavailable event to node server
        
        this.$store.state.settings.steps[5].payload.anytimeServices = false;
        this.$store.state.settings.steps[5].isLoading = true;
        this.updateTimetable();
                
        this.$socket.emit('anytime_specialist', {event: 'unavailable', queue_channel: this.queueChannel});
      },
      sendMessage() {
        this.message = this.message.trim();

        if (this.message.length === 0) {
          return;
        }

        //I.Create message object & append it client-side
        const newMessage = {}
        let dateNow = new Date();
        newMessage.created_at = dateNow.toISOString();
        newMessage.text = this.message;

        this.chat.push(newMessage);

        // scroll to bottom of div
        setTimeout(() => {
          this.$refs.chat.scrollTop = this.$refs.chat.scrollHeight;
        }, 100);


        //II.Broadcast message to server
        let responseData = {
          event: 'announcement',
          specialist_id: this.user.id,
          message: newMessage.text
        };

        this.$socket.emit('anytime_specialist', responseData);

        //III.Clear message box
        this.message = '';
      },
      joinQueueChannel(){
        //I.Create queue channel string {{specialistId_specialistFullName_queue}}
        console.log(this.user);
        this.queueChannel = this.user.id + '_' + (this.user.full_name).replace(/\s/g, '','') + '_queue';

        //II.Subscribe to queue channel for incoming data
        this.sockets.subscribe(this.queueChannel, data => {
          switch (data.event){
            case 'queue': //This doesn't get sent anymore, now you directly get a response at join
              this.queue = data.queue;
              this.chat = data.messages;
              
              break;
            case 'invite_accept':
              let meetingUrl = "/anytime-meetingroom?token=" + data.token;
			        this.$router.push(meetingUrl);
              break;
          }

        });

        //III.Emit on anytime_specialist in order to get receive the queue
        let eventData = {
          event: 'join',
          queue_channel: this.queueChannel,
          specialist_id: this.user.id,
        }

        this.$socket.emit('anytime_specialist', eventData);

      },
      refreshQueue(){
        let queueCopy = [...this.queue];
        this.queue = [];
        this.queue = queueCopy;
      }
    },
    watch: {
      '$store.state.user.user.full_name': {
        handler(newVal) {
          if (newVal != null) {
            this.joinQueueChannel(); //join queue channel only after user state is loaded
          }
        },
          immediate: true
      }
    },
    mounted(){
      //Queue refresher | 60000 = 1 min;
      setInterval(() => {this.refreshQueue(); console.log('queue refreshed!')}, 60000);

      //Refresh user state if already loaded | check if we have the user in state first
      if(this.user.full_name) this.refreshUser();
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/scss/pages/anytime-meetings";

  .anytime-meetings__warning {
    margin-left: auto;
    margin-right: auto;
    max-width: 300px;
    padding-bottom: 45px;
    padding-top: 30px;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.4;
  }

  h3.anytime-meetings__warning {
    color: $color-primary;
    padding-bottom: 0;
  }

  h4.anytime-meetings__warning {
    font-size: 16px;
    font-weight: 400;
  }

  .page-container__body {
    display: flex;
    flex: 1;
    height: calc(100vh - 220px);
    width: 100%;


    @media only screen and (max-width: 850px) {
      & > :first-child,
      & > :last-child {
        max-width: 100%;
        width: 100%;
      }

      & > :last-child {
        display: none;
        margin-left: 0;
      }

      &.show-chat {
        & > :first-child {
          display: none;
        }

        & > :last-child {
          display: flex;
        }
      }
    }
  }
</style>
